import { format } from "date-fns";

export const updateImagePengecekanMobilDetilSingle = (detil) => {
  let newImage = detil.gambar;
  if (newImage) {
    if (!newImage.includes("?serial=")) {
      newImage = `${newImage}?serial=${Math.random()}`;
    }
  }
  return { ...detil, gambar: newImage };
};

export const generateUpdatedImagePengecekanMobil = (detils) => {
  return detils.map((detil) => updateImagePengecekanMobilDetilSingle(detil));
};

// Client-only flags of a detil row that the backend must not get (see stripClientFlags):
//   _localId  a marking staged by Beri Tanda, it has no id until it is saved
//   _dirty    the row was changed on this page and not saved yet. Saving puts the rows the server sent back in
//             place of these ones (mergeSavedDetils), which is what clears it.
export const stripClientFlags = ({ _localId, _dirty, ...rest }) => rest;

// a row that exists only on this page (no id) or was changed since it was loaded / saved
export const isUnsavedDetil = (detil) => !detil.id || !!detil._dirty;

// "saved" | "unsaved" | null for the SavedBadge of a card that shows `detils`
//   hasContent: whether the card has something that counts as saved when no row is unsaved
export const getSavedStatus = (detils, hasContent) => {
  if (detils.some(isUnsavedDetil)) return "unsaved";
  return hasContent ? "saved" : null;
};

// folder of the file manager the row photos go to: <date>/<nomor polisi>
export const getFotoFolderName = (headerData) => {
  const nomorPolisi = headerData.data_kendaraan
    ? headerData.data_kendaraan.nomor_polisi
    : null;
  const today = format(new Date(), "yyyy-MM-dd");
  return (nomorPolisi ? `${today}/${nomorPolisi}` : today).replaceAll(" ", "-");
};

export const convertSaveHeader =(data, extraDeleteKeys = []) => {
  const value = { ...data };

  const { tanggal_transaksi, tanggal_transaksi_jam } = value;
  value.tanggal_transaksi = new Date(
    tanggal_transaksi.getFullYear(),
    tanggal_transaksi.getMonth(),
    tanggal_transaksi.getDate(),
    tanggal_transaksi_jam.getHours(),
    tanggal_transaksi_jam.getMinutes(),
    0
  );
  value.tanggal_transaksi = format(
    value.tanggal_transaksi,
    "yyyy-MM-dd HH:mm:00"
  );

  delete value.tanggal_transaksi_jam;
  delete value.tanggal_berangkat;
  delete value.tanggal_kembali;

  delete value.data_kendaraan;
  delete value.data_pemakai;
  delete value.data_supir;
  delete value.data_tujuan;

  // keys that only one variant (mobil / trado) has to strip, see editorConfig.saveHeaderDeleteKeys
  extraDeleteKeys.forEach((key) => delete value[key]);

  return value;
};

export const convertLoadedHeader = (data) => {
  const newData = { ...data };

  const { tanggal_transaksi, tanggal_berangkat, tanggal_pulang } = newData;

  if (tanggal_berangkat)
    newData.tanggal_berangkat = new Date(tanggal_berangkat);
  if (tanggal_pulang) newData.tanggal_pulang = new Date(tanggal_pulang);

  if (tanggal_transaksi) {
    newData.tanggal_transaksi = new Date(tanggal_transaksi);
    newData.tanggal_transaksi_jam = new Date(tanggal_transaksi);
  }

  if (!newData.keterangan) {
    newData.keterangan = "";
  }

  return newData;
};

// Puts the rows the server sent back (`data`) in place of the rows of `detils` that have the same id.
export const mergeSavedDetils = (detils, data) => {
  const merged = detils.map((detil) => {
    const found = data.find((d) => d.id === detil.id);
    if (found) return found;
    return detil;
  });
  return generateUpdatedImagePengecekanMobil(merged);
};

// Like mergeSavedDetils, but also resolves rows that were only staged locally (no id yet, a marking added with
// Beri Tanda but not saved until the batch Save button is pressed - see MarkingList.js / useEditorMarking.js).
// sentDetils: the exact array that was sent (still carrying each row's _localId), in the same order as `data`
// (the backend's savemany preserves order), so a staged row is resolved by position, then matched back by _localId.
export const mergeSavedMarkingDetils = (detils, sentDetils, data) => {
  const byLocalId = {};
  sentDetils.forEach((sent, i) => {
    if (!sent.id && sent._localId && data[i]) {
      byLocalId[sent._localId] = data[i];
    }
  });

  const merged = detils.map((detil) => {
    if (detil._localId && byLocalId[detil._localId]) {
      return byLocalId[detil._localId];
    }
    const found = data.find((d) => d.id === detil.id);
    if (found) return found;
    return detil;
  });
  return generateUpdatedImagePengecekanMobil(merged);
};

// the header fields the user can change, compared with the header as it was loaded / saved (see isHeaderDirty)
const headerEditableFields = [
  "tanggal_transaksi",
  "tanggal_transaksi_jam",
  "kendaraan_id",
  "pemakai_id",
  "supir_id",
  "supir_pulang_id",
  "tujuan_id",
  "trailer_id",
  "trailer_berangkat_id",
  "trailer_pulang_id",
  "jumlah_orang",
  "speedo_mulai",
  "speedo_akhir",
  "keterangan",
];

// empty / 0 / null / undefined are the same "nothing" (a new header starts with 0, a loaded one has null)
const normalizeHeaderValue = (value) => {
  if (value instanceof Date) return value.getTime();
  if (value === undefined || value === null || value === "" || value === 0) {
    return null;
  }
  return value;
};

// the header has changes that were not saved: savedHeader is the header as the server last sent it
// (null: not known yet, nothing to compare)
export const isHeaderDirty = (headerData, savedHeader) => {
  if (!savedHeader) return false;
  return headerEditableFields.some(
    (field) =>
      normalizeHeaderValue(headerData[field]) !==
      normalizeHeaderValue(savedHeader[field])
  );
};
